import { API_HOST } from "./config"
export default {
  // CLINIC ROUTES
  ALL_RECOMMENDATIONS: `${API_HOST}clinics/recommendation/get`,
  UPDATE_RECOMMENDATIONS: `${API_HOST}clinics/recommendation/update`,
  SEARCH_RECOMMENDATIONS: `${API_HOST}clinics/recommendation/search`

}
